var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "full_battery",
    "data-name": "full battery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.6373 31.3707a2.0858 2.0858 0 0 1 -1.504.6293h-12.8a2.14 2.14 0 0 1 -2.1333-2.1333v-23.4667a2.14 2.14 0 0 1 2.1333-2.1333h12.8a2.14 2.14 0 0 1 2.1334 2.1333v24.0381z",
    fill: "#4d4d4d",
    "data-original": "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2667 26.6667v3.7759l-.6294.928a2.0851 2.0851 0 0 1 -1.504.6294h-12.8a2.14 2.14 0 0 1 -2.1333-2.1333v-3.2z",
    fill: "#a6e063",
    "data-original": "#a6e063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 21.333h17.067v5.333h-17.067z",
    fill: "#8ad64d",
    "data-original": "#8ad64d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 16h17.067v5.333h-17.067z",
    fill: "#34d143",
    "data-original": "#34d143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 10.667h17.067v5.333h-17.067z",
    fill: "#06c458",
    "data-original": "#06c458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4667 0h4.5333a2 2 0 0 1 2 2v2.2667a0 0 0 0 1 0 0h-8.5333a0 0 0 0 1 0 0v-2.2667a2 2 0 0 1 2-2z",
    fill: "#333333",
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4,
    cy: 25.6,
    fill: "#f2f2f2",
    r: 6.4,
    "data-original": "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6927 28.087a1.066 1.066 0 0 1 -.7542-.3125l-1.426-1.4266a1.0665 1.0665 0 1 1 1.5083-1.5079l.6719.6719 2.0865-2.086a1.0666 1.0666 0 0 1 1.5083 1.5084l-2.8406 2.8406a1.066 1.066 0 0 1 -.7542.3121z",
    fill: "#34d143",
    "data-original": "#34d143"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStock);
export default __webpack_public_path__ + "static/media/full-stock.f8e05ba7baa33e35a008fc32d4c26832.svg";
export { ForwardRef as ReactComponent };